angular.module 'app'
.controller 'ListTemplateCtrl', ($rootScope, $scope, $http, $state, $stateParams, config, Storage, dialogs, growl,$timeout) ->

  $scope.ui =
    isLoading: false
    user: Storage.get('login_user')
    list_id: []
    publishLists: []
    _id: ''
    sortshow: true
    cancel: false
    disabled: true
    editId: ''
    default_name: ''
    resourcesUrl: config.api.baseUrl

  #修改名稱
  $scope.groupPopover =
    isOpen: false
    title: "請填寫模板名稱"
    name: $scope.ui.default_name
    templateUrl: 'groupPopoverTemplate.html'
    open: ->
      $scope.groupPopover.isOpen = true
    close: ->
      $scope.groupPopover.isOpen = false
    save: ->
      $scope.ui.default_name = $scope.groupPopover.modify_name
      $scope.groupPopover.isOpen = false


  fetchWechat = ->
    $http.get "#{config.api.baseUrl}/wechat?access_token=" + Storage.get('access_token'),
      params:
        user_group_id: $scope.ui.user.group_id
        original_id: $stateParams.original_id
    .then (res) ->
      $scope.ui.default_name = res.data.data[0].name if res.data.count > 0

  # 通过_id查找到相关数据
  findData = ->
    $http.get "#{config.api.baseUrl}/homepage/getOne/#{$stateParams._id}?access_token=" + Storage.get('access_token'),
      params: {}
    .then (res) ->
      # _.each res.data.list, (val) ->
      #   val.thumb_url = config.api.baseUrl + '/imgserve?_url=' + val.thumb_url if val.thumb_url.indexOf('mmbiz.qpic.cn') >= 0 and val.thumb_url.indexOf(config.api.baseUrl) < 0
      $scope.ui.publishLists = res.data.list
      $scope.ui.default_name = res.data.name
      _.each res.data.list, (data) ->
        $scope.ui.list_id .push(data.sent_id)
        $scope.groupPopover.name = res.data.name

  ### 初始化 ###
  if $stateParams._id
    $scope.ui.editId = $stateParams._id
    findData()
  else
    fetchWechat()

  # 添加
  $scope.add = ->
    dlg = dialogs.create('apps/page-template/add-template/add-template', 'AddListTemplateCtrl', {appmsg: reply_state: 4}, {size: 'lg'})
    dlg.result.then ((option) ->
      return if option == 'Cancel'
      # _.each option.list, (val) ->
        # val.thumb_url = config.api.baseUrl + '/imgserve?_url=' + val.thumb_url if val.thumb_url.indexOf('mmbiz.qpic.cn') >= 0 and val.thumb_url.indexOf(config.api.baseUrl) < 0
      $scope.ui.publishLists = _.union($scope.ui.publishLists,option.list)
      $scope.ui.list_id = _.union($scope.ui.list_id,option.list_id)
    ), ->

  # 删除
  $scope.deletePublish = (publish) ->
    $scope.ui.publishLists = _.filter($scope.ui.publishLists, (d) -> d.sent_id isnt publish.sent_id)
    $scope.ui.list_id = _.filter($scope.ui.list_id,(d) -> d isnt publish.sent_id)


  $scope.back = ->
    $state.go('app.pagetemplate')

  #發佈
  $scope.release = ->
    if $stateParams._id
      $http.put "#{config.api.baseUrl}/homepage/update/#{$stateParams._id}?access_token=" + Storage.get('access_token'),
        list: $scope.ui.list_id
        name: $scope.ui.default_name
      .then (res) ->
        growl.success "發佈成功！"
      .finally ->
        $state.go('app.pagetemplate')
        $scope.ui.isLoading = false
      .catch (error) ->
        if error.data.error.indexOf('errtext') >= 0
          err = JSON.parse error.data.error
          growl.error err.errtext
        else
          growl.error('網絡連接失敗，請稍後重試')
    else
      if $scope.ui.list_id.length == 0
        return growl.error('請至少選擇一篇文章')
      $http.post "#{config.api.baseUrl}/homepage/add/?access_token=" + Storage.get('access_token'),
        list: $scope.ui.list_id
        original_id: $stateParams.original_id
        name: $scope.ui.default_name
      .then (res) ->
        growl.success "發佈成功！"
      .finally ->
        $state.go('app.pagetemplate')
        $scope.ui.isLoading = false
      .catch (error) ->
        if error.data.error.indexOf('errtext') >= 0
          err = JSON.parse error.data.error
          growl.error err.errtext
        else
          growl.error('網絡連接失敗，請稍後重試')

  # 開啟排序功能
  $scope.sortt = ->
    $scope.ui.sortshow = false
    $scope.ui.cancel = true

  # 排序（拖拽移動）
  $scope.sortableOptions =
    update: (e, ui) ->
      $timeout ->
        resArr = []
        i = 0
        while i < $scope.ui.publishLists.length
          resArr.push $scope.ui.publishLists[i].sent_id
          i++
        $scope.ui.list_id = resArr
        return
      return
    stop: (e, ui) ->
      return

  # 取消排序
  $scope.tocancel = ->
    $scope.ui.sortshow = true
    $scope.ui.cancel = false


